/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SwitchProfileResponseDTO
 */
export interface SwitchProfileResponseDTO {
	/**
	 *
	 * @type {string}
	 * @memberof SwitchProfileResponseDTO
	 */
	token: string;
}

export function SwitchProfileResponseDTOFromJSON(
	json: any
): SwitchProfileResponseDTO {
	return SwitchProfileResponseDTOFromJSONTyped(json, false);
}

export function SwitchProfileResponseDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SwitchProfileResponseDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		token: json["token"],
	};
}

export function SwitchProfileResponseDTOToJSON(
	value?: SwitchProfileResponseDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		token: value.token,
	};
}
